export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  
  { text: 'Code', align: 'start', value: 'employeeCode', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'employeeCode')?.value) return true
        return value.includes(filters.find(x=>x.name === 'employeeCode')?.value)
      }
  },
  { text: 'Name', align: 'start', value: 'employeeName', width: '10rem',
      filter: value => {
        if ( !filters.find(x=>x.name === 'employeeName')?.value) return true
        return value.includes(filters.find(x=>x.name === 'employeeName')?.value)
      }
  },
  { text: 'Department', align: 'start', value: 'departmentName', width: '7rem',
      filter: value => true
  },
  
  { text: 'Position', align: 'start', value: 'positionName', width: '7rem',
      filter: value => true
  },
  
  { text: 'PositionState', align: 'start', value: 'positionStateName', width: '7rem',
      filter: value => true
  },
  
  { text: 'Image', align: 'start', value: 'attachmentUrl', width: '7rem',
      filter: value => true
  },

  { text: 'CheckIn', align: 'start', value: 'createdAt', width: '7rem',
      filter: value => true
  },
  
  { text: 'Event', align: 'start', value: 'eventName', width: '150px',
      filter: value => true
  },

]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const finalHeaders = [
  // {text: '', value: 'actions', width: 100},
  { text: 'Tháng', align: 'start', value: 'month', width: '7rem' },
  // { text: 'Tổng phiếu', align: 'start', value: 'count' },
  { text: 'Số nhân sự', align: 'start', value: 'employeeCount' },
  { text: 'Số NVM', align: 'start', value: 'final.totalReviewNvm' },
  { text: 'Số NVM đạt', align: 'start', value: 'final.completeNvm' },
  { text: 'Số COT2', align: 'start', value: 'final.totalReviewCot2' },
  { text: 'Số COT2 đạt', align: 'start', value: 'final.completeCot2' },
  // { text: 'Trạng thái', align: 'start', value: 'status' },
  { text: 'Chốt kỳ', align: 'start', value: 'setFinal' },
  { text: 'Reset', align: 'start', value: 'resetFinal' },
  // { text: 'Chưa hoàn tất NVM', align: 'start', value: 'incompleteNvm' },
  // { text: 'Hoàn tất NVM', align: 'start', value: 'completeNvm' },
  // { text: 'Tổng phiếu NVM', align: 'start', value: 'totalReviewNvm' },
  // { text: 'Chưa hoàn tất COT2', align: 'start', value: 'incompleteCot2' },
  // { text: 'Hoàn tất COT2', align: 'start', value: 'completeCot2' },
  // { text: 'Tổng phiếu COT2', align: 'start', value: 'totalReviewCot2' },
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Ngày nhận việc', align: 'start', value: 'hireDate' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]